import { Injectable } from '@angular/core';
import { IFlyerVOList } from '../interfaces/beni-conto-deposito';
import { IGridRows, StepInterface } from '@poste-click-connect/shared-ui';
import { initialStepperData } from '../utils/on-consignment.utils';

@Injectable({
  providedIn: 'root'
})
export class PackageWarehouseService {
  private _causalCloseBox: string | null = null;
  private _fileIsPrinted: boolean = false;
  private _counterPackage: number = 0;
  private _flyerListInBox: IFlyerVOList[] = [];
  private _expiredFlyerList: IFlyerVOList[] = [];
  private _flyerLost: IFlyerVOList[] = [];
  private _totalFlyerStep2: IFlyerVOList[] = [];
  private _totalFlyerWorked: IFlyerVOList[] = [];
  private _stepperData: StepInterface[] = initialStepperData;
  private _gridRowStep2: IGridRows[] = [];
  private _isCloseBoxWorkflow: boolean = false;
  private _isFromRiapriScatola: boolean = false;
  private _boxNumber: number = 1;

  setIsFromRiapriScatola(active: boolean){
    this._isFromRiapriScatola = active;
  }
  get isFromRiapriScatola(): boolean{
    return this._isFromRiapriScatola;
  }

  setIsCloseBoxWorkflow(active: boolean){
    this._isCloseBoxWorkflow = active;
  }
  get isCloseBoxWorkflow(): boolean{
    return this._isCloseBoxWorkflow;
  }

  setCausalCloseBox(causal: string | null){
    this._causalCloseBox = causal;
  }
  get causalCloseBox(): string | null{
    return this._causalCloseBox;
  }

  setFileIsPrinted(active: boolean){
    this._fileIsPrinted = active;
  }
  get fileIsPrinted(): boolean{
    return this._fileIsPrinted;
  }

  addCounterPackage(){
    this._counterPackage += 1;
  }
  resetCounterPackage(){
    this._counterPackage = 0;
  }
  get counterPackage(): number{
    return this._counterPackage;
  }

  setFlyerListInBox(list: IFlyerVOList[]){
    this._flyerListInBox = list;
  }
  get flyerListInBox(): IFlyerVOList[]{
    return this._flyerListInBox;
  }

  setExpiredFlyerList(list: IFlyerVOList[]){
    this._expiredFlyerList = list;
  }
  get expiredFlyerList(): IFlyerVOList[]{
    return this._expiredFlyerList;
  }

  setFlyerLost(list: IFlyerVOList[]){
    this._flyerLost = list;
  }
  get flyerLost(): IFlyerVOList[]{
    return this._flyerLost;
  }

  setTotalFlyerStep2(list: IFlyerVOList[]){
    this._totalFlyerStep2 = list;
  }
  get totalFlyerStep2(): IFlyerVOList[]{
    return this._totalFlyerStep2;
  }

  setGridRowStep2(gridRow: IGridRows[]){
    this._gridRowStep2 = gridRow;
  }
  get gridRowStep2(): IGridRows[]{
    return this._gridRowStep2;
  }

  setTotalFlyerWorked(list: IFlyerVOList[]){
    this._totalFlyerWorked = list;
  }
  get totalFlyerWorked(): IFlyerVOList[]{
    return this._totalFlyerWorked;
  }

  setStepperData(stepper: StepInterface[]){
    this._stepperData = stepper;
  }
  get stepperData(): StepInterface[]{
    return this._stepperData;
  }

  setBoxNumber(boxNumber: number){
    this._boxNumber = boxNumber;
  }
  get boxNumber(): number{
    return this._boxNumber;
  }

  resetServiceData(): void{
    this._causalCloseBox = null;
    this._fileIsPrinted = false;
    this._counterPackage = 0;
    this._flyerListInBox = [];
    this._expiredFlyerList = [];
    this._flyerLost = [];
    this._totalFlyerStep2 = [];
    this._totalFlyerWorked = [];
    this._stepperData = initialStepperData;
    this._gridRowStep2 = [];
    this._isCloseBoxWorkflow = false;
    this._isFromRiapriScatola = false;
    this._boxNumber = 1
  }
}
